import React, { Component } from 'react';
import { Grid } from 'semantic-ui-react';
import { Helmet } from 'react-helmet';
import './organization.css';

export class OrganizationBrief extends Component {
	constructor(props) {
		super(props);
		this.state = {
			activeOrganization: "",
		};
	}

	componentDidMount() {
		const activeOrganization = localStorage.getItem('activeOrganization');
		this.setState({ activeOrganization: activeOrganization });
	}


	render() {
		return (
			<Grid>
				<div className='briefContainer'>
					<div className="briefHeading">organization</div>
					<div className='briefNameContainer'>
						<div className='briefName'>{this.state.activeOrganization}</div>
						<div className='organizationChange'><a href='/myorganization'>Change</a></div>
					</div>
					<div className='addUsersLink'>
						<a href='/myorganization/add-new-user'>ADD NEW USERS</a>
					</div>
				</div>
			</Grid>
		)
	}
}

export default OrganizationBrief


// WEBPACK FOOTER //
// ./src/Modules/MyOrganization/OrganizationBrief.jsx